"use client";

import { ResponsiveModal } from "@/components/responsive-modal";
import useManualQuestionModal from "../hooks/use-manual-question-modal";
import { NewManualQuestionForm } from "./new-manual-question.form";

export const NewQuestionModal = () => {
  const { isOpen, onClose } = useManualQuestionModal();

  return (
    <ResponsiveModal
      title="Create Question"
      description="Manually create a question"
      open={isOpen}
      onOpenChange={onClose}
      form={<NewManualQuestionForm />}
    />
  );
};
